import UserOrdersPageComponent from "./components/UserOrdersPageComponent";

import axios from "axios";

const getOrders = async() => {
    const { data } = await axios.get("/api/orders/admin");
    return data
}

const fetchOrdersAdmin = async (abctrl) => {
  const {data} = await axios.get("/api/orders/admin", {
      signal: abctrl.signal,
  });
  return data
}

const fetchOrders = async (userId) => {
  console.log("[USER fetchOrders] userId=",userId)
  const {data} = await axios.get(`/api/orders/user/${userId}`);
  return data
}

const deleteOrder = async (userId) => {
  const { data } = await axios.delete(`/api/orders/${userId}`);
  return data
}

const UserOrdersPage = () => {
  return <UserOrdersPageComponent fetchOrders={fetchOrders} deleteOrder={deleteOrder} />
};

export default UserOrdersPage;
